"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInputType = void 0;
const audiCodeRegEx = /^[A-Z0-9]+$/;
const carLineRegEx = /^[a-z0-9_-]+$/;
const isAudiCode = (value) => audiCodeRegEx.test(value);
const isCarLine = (value) => carLineRegEx.test(value);
const getInputType = (input) => {
    if (isCarLine(input)) {
        return 'carline';
    }
    else if (isAudiCode(input)) {
        return 'audicode';
    }
    return '';
};
exports.getInputType = getInputType;
//# sourceMappingURL=InputType.js.map